<ng-template #ausstallenFormInner>
    <!-- Kommentar und Ausstalldatum ganz oben -->
    <h5 class="ausstallen-section-heading">Einstellungen</h5>
    <mat-form-field style="width: 100%">
        <mat-label>Kommentar</mat-label>
        <textarea [formControl]="kommentarCtrl" matInput rows="1" type="text"></textarea>
    </mat-form-field>

    <mat-form-field style="width: 100%">
        <mat-label>Ausstalldatum</mat-label>
        <input
            [formControl]="datumCtrl"
            [matDatepicker]="picker"
            [required]="embeddedInStepper || mobileFinishMode"
            readonly="true"
            matInput
            (dateChange)="onAusstalldatumChanged()"
        />
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <button
            *ngIf="!embeddedInStepper && !mobileFinishMode"
            (click)="datumCtrl.setValue(undefined)"
            mat-icon-button
            matSuffix
            type="button"
        >
            <mat-icon>clear</mat-icon>
        </button>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="datumCtrl.hasError('required')">Ausstalldatum ist erforderlich</mat-error>
    </mat-form-field>

    <ng-container *ngIf="mobileFinishMode">
        <mat-form-field style="width: 100%">
            <mat-label>Bezeichnung / KFZ-Kennzeichen Transportfahrzeug</mat-label>
            <input [formControl]="kfzCtrl" matInput type="text" />
        </mat-form-field>

        <div *ngIf="showReklamationenWeitergeben" style="width: 100%">
            <mat-checkbox [(ngModel)]="tierliste.reklamationen_weitergeben">
                <span style="white-space: normal">Tierreklamationen weitergegeben</span>
            </mat-checkbox>
        </div>
    </ng-container>

    <div *ngIf="showHitAbgangMelden" style="margin-top: 12px">
        <p style="font-size: 0.9em">
            Sollen die Tiere mit dem Datum
            {{ datumCtrl.value | date: "dd.MM.yyyy" }} in HIT als Abgang gemeldet werden? Die Abgänge werden erst nach
            diesem Datum gemeldet.
        </p>
        <mat-radio-group aria-label="Abgang an HIT melden ja oder nein" [formControl]="hitMeldenCtrl">
            <mat-radio-button [value]="0">nein</mat-radio-button>
            <mat-radio-button [value]="1">ja</mat-radio-button>
        </mat-radio-group>
        <div *ngIf="showGewichteImportieren" style="margin-top: 12px">
            <mat-checkbox [formControl]="gewichteImportierenCtrl">
                Empfänger darf die Gewichte importieren
            </mat-checkbox>
        </div>
    </div>

    <mat-divider style="margin: 16px 0"></mat-divider>

    <!-- Zielbetrieb bei internem Umstallen (nach Tiere hinzufügen) -->
    <ng-container *ngIf="data.intern && hasTiereOnTierliste">
        <h5>Zielbetrieb</h5>
        <div *ngIf="hasZielbetriebSelected" class="one-row">
            <mat-card class="kontakt-card">
                <h3>{{ zielbetrieb?.bezeichnung_final || tierliste?.kunde_einstallen }}</h3>
                <p *ngIf="zielbetrieb?.zusatz_final || tierliste?.kunde_zusatz_einstallen"
                    ><b>{{ zielbetrieb?.zusatz_final || tierliste?.kunde_zusatz_einstallen }}</b></p
                >
                VVVO: {{ zielbetrieb?.vvvo || tierliste?.kunde_vvvo_einstallen || "---" }}<br />
                <ng-container *ngIf="zielbetrieb; else zielbetriebFromTierliste">
                    {{ zielbetrieb.strasse }}<br />
                    {{ zielbetrieb.plz }} {{ zielbetrieb.ort }}
                </ng-container>
                <ng-template #zielbetriebFromTierliste>
                    {{ tierliste?.kunde_strasse_einstallen }}<br />
                    {{ tierliste?.kunde_plz_einstallen }} {{ tierliste?.kunde_ort_einstallen }}
                </ng-template>
            </mat-card>
            <span class="spacer"></span>
            <button type="button" (click)="clearZielbetrieb()" mat-icon-button aria-label="Zielbetrieb entfernen">
                <mat-icon>delete</mat-icon>
            </button>
            <button type="button" (click)="zielbetriebAendern()" mat-icon-button aria-label="Zielbetrieb bearbeiten">
                <mat-icon>edit</mat-icon>
            </button>
        </div>
        <button *ngIf="!hasZielbetriebSelected" type="button" (click)="zielbetriebAendern()" color="accent" mat-stroked-button>
            Zielbetrieb auswählen
        </button>
        <mat-divider *ngIf="!embeddedInStepper" style="margin-top: 5px"></mat-divider>
    </ng-container>

    <!-- Schlachthof nur anzeigen, wenn es eine neue Tierliste ist (keine bestehende Tierliste zum Bearbeiten) -->
    <ng-container *ngIf="!data.intern && !data.tierliste">
        <div class="ausstallen-schlachthof-block">
            <h5 class="ausstallen-section-heading">Schlachthof</h5>
            <div class="one-row">
                <button type="button" (click)="openContactDialog('Schlachthof')" *ngIf="!schlachthof" color="accent" mat-stroked-button
                    >Schlachthof auswählen
                </button>
                <ng-container *ngIf="schlachthof">
                    <mat-card class="kontakt-card" (click)="openContactDialog('Schlachthof')">
                        <h3>{{ schlachthof.bezeichnung }}</h3>
                        <p *ngIf="schlachthof.zusatz"
                            ><b>{{ schlachthof.zusatz }}</b></p
                        >
                        VVVO: {{ schlachthof.vvvo ? schlachthof.vvvo : "---" }}<br />
                        {{ schlachthof.strasse }}<br />
                        {{ schlachthof.plz }} {{ schlachthof.ort }}
                    </mat-card>
                    <span class="spacer"></span>
                    <button type="button" (click)="deleteSchlachthof()" mat-icon-button>
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button type="button" (click)="openContactDialog('Schlachthof')" mat-icon-button>
                        <mat-icon>edit</mat-icon>
                    </button>
                </ng-container>
            </div>
            <mat-divider class="ausstallen-section-divider"></mat-divider>
        </div>
    </ng-container>

    <!-- Stepper: Empfänger wie im Detail-Dialog (Karte + Modal) -->
    <ng-container *ngIf="useModalEmpfaengerPicker">
        <ng-container *kienePermission="[9601]">
            <div class="ausstallen-empfaenger-card">
                <div class="ausstallen-empfaenger-card__head">
                    <span class="ausstallen-empfaenger-card__label">
                        <mat-icon aria-hidden="true">local_shipping</mat-icon>
                        Empfänger
                    </span>
                    <button
                        type="button"
                        class="ausstallen-empfaenger-card__edit"
                        [attr.aria-label]="empfaengerCardAriaLabel"
                        (click)="openEmpfaengerModal($event)"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>
                <div
                    *ngIf="empfaengerDisplayEntries.length > 0; else empfaengerEmpty"
                    class="ausstallen-empfaenger-card__list"
                >
                    <div
                        *ngFor="let entry of empfaengerDisplayEntries; trackBy: trackEmpfaengerDisplayEntry"
                        class="ausstallen-empfaenger-card__entry"
                    >
                        <p class="ausstallen-empfaenger-card__value">{{ entry.name }}</p>
                        <p
                            *ngFor="let line of entry.detailLines; trackBy: trackEmpfaengerDetailLine"
                            class="ausstallen-empfaenger-card__detail"
                        >
                            {{ line }}
                        </p>
                    </div>
                </div>
                <ng-template #empfaengerEmpty>
                    <p class="ausstallen-empfaenger-card__value ausstallen-empfaenger-card__value--muted">
                        Kein Empfänger ausgewählt
                    </p>
                </ng-template>
            </div>
        </ng-container>
    </ng-container>

    <!-- Neue Betriebskontakt-Auswahl für Multi-Empfänger -->
    <ng-container *ngIf="!useModalEmpfaengerPicker && showKontakteAuswahl && !data.intern">
        <ng-container *kienePermission="[9601]">
            <div class="kontakte-auswahl-section">
                <div class="kontakte-auswahl-container">
                    <kiene-betriebskontakt-auswahl
                        [config]="kontakteConfig"
                        [selectedKontakte]="tempSelectedKontakte"
                        [disabled]="isSaving"
                        (kontakteSelected)="onKontakteAusgewaehlt($event)"
                        (selectionChanged)="onKontakteSelectionChanged($event)"
                    >
                    </kiene-betriebskontakt-auswahl>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <!-- Anzeige der ausgewählten Kontakte -->
    <ng-container *ngIf="!useModalEmpfaengerPicker && showSelectedKontakte && !data.intern">
        <ng-container *kienePermission="[9601]">
            <div class="selected-kontakte-section">
                <div class="selected-kontakte-header">
                    <h5>Ausgewählte Empfänger</h5>
                    <button type="button" mat-button color="accent" (click)="kontakteBearbeiten()" class="edit-button">
                        <mat-icon>edit</mat-icon>
                        Bearbeiten
                    </button>
                </div>
                <div class="selected-kontakte-grid" *ngIf="selectedKontakte.length > 0">
                    <div *ngFor="let kontakt of selectedKontakte" class="selected-kontakt-card">
                        <kiene-betriebskontakt-card
                            [kontakt]="kontakt"
                            [config]="getKontaktCardConfig(kontakt)"
                            (entfernen)="removeKontakt($event)"
                            (hinzufuegen)="kontaktHinzufuegen($event)"
                        >
                        </kiene-betriebskontakt-card>
                    </div>
                </div>
                <div *ngIf="selectedKontakte.length === 0" class="no-contacts-message">
                    <p>Keine Empfänger ausgewählt. Klicken Sie auf "Bearbeiten" um Kontakte hinzuzufügen.</p>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <mat-divider style="margin: 16px 0"></mat-divider>

    <section class="ausstallen-haendler-section">
        <h5 class="ausstallen-section-heading">Händler</h5>
        <p class="ausstallen-haendler-hint">Optional: Viehhändler oder Betriebskontakt hinterlegen.</p>

        <div class="ausstallen-haendler-switch">
            <button
                type="button"
                mat-stroked-button
                class="ausstallen-haendler-switch__button"
                [class.ausstallen-haendler-switch__button--active]="haendlerSourceMode === 'none'"
                (click)="setHaendlerSourceMode('none')"
            >
                Keiner
            </button>
            <button
                type="button"
                mat-stroked-button
                class="ausstallen-haendler-switch__button"
                [class.ausstallen-haendler-switch__button--active]="haendlerSourceMode === 'haendler'"
                (click)="setHaendlerSourceMode('haendler')"
            >
                Händler
            </button>
            <button
                *kienePermission="[9601]"
                type="button"
                mat-stroked-button
                class="ausstallen-haendler-switch__button"
                [class.ausstallen-haendler-switch__button--active]="haendlerSourceMode === 'kontakt'"
                (click)="setHaendlerSourceMode('kontakt')"
            >
                Kontakt
            </button>
        </div>

        <div class="ausstallen-haendler-panel" *ngIf="haendlerSourceMode === 'haendler'">
            <div *ngIf="haendlerFavoritenLoading" class="ausstallen-haendler-empty ausstallen-haendler-empty--compact">
                <p>Händler werden geladen…</p>
            </div>

            <div *ngIf="showHaendlerFavoritenEmptyState" class="ausstallen-haendler-empty">
                <mat-icon>storefront</mat-icon>
                <p class="ausstallen-haendler-empty__title">Keine Händler hinterlegt</p>
                <p class="ausstallen-haendler-empty__hint">
                    Legen Sie Favoriten-Händler an, um sie beim Ausstallen schnell zuzuordnen.
                </p>
                <button
                    *ngIf="canEditHaendler"
                    mat-stroked-button
                    color="accent"
                    type="button"
                    (click)="openHaendlerVerwaltung()"
                >
                    Händler anlegen
                </button>
            </div>

            <div class="ausstallen-haendler-row" *ngIf="!haendlerFavoritenLoading && haendlerFavoriten.length > 0">
                <mat-form-field class="ausstallen-haendler-field">
                    <mat-label>Händler auswählen</mat-label>
                    <mat-select
                        [disabled]="isSaving"
                        [compareWith]="compareHaendler"
                        [formControl]="haendlerCtrl"
                        (selectionChange)="onHaendlerSelected()"
                    >
                        <mat-option [value]="null"> - kein Händler - </mat-option>
                        <mat-option *ngFor="let haendler of haendlerFavoriten" [value]="haendler">
                            {{ haendler.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <button
                    *kienePermission="[9132]"
                    (click)="openHaendlerVerwaltung()"
                    mat-icon-button
                    color="accent"
                    [disabled]="!canEditHaendler"
                    type="button"
                >
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>

        <div class="ausstallen-haendler-panel" *ngIf="haendlerSourceMode === 'kontakt'">
            <ng-container *kienePermission="[9601]">
                <div *ngIf="selectedHaendlerKontakte.length > 0">
                    <kiene-betriebskontakt-card
                        [kontakt]="selectedHaendlerKontakte[0]"
                        [config]="haendlerKontaktCardConfig"
                        (entfernen)="onHaendlerKontaktEntfernen()"
                    >
                    </kiene-betriebskontakt-card>
                </div>

                <div *ngIf="selectedHaendlerKontakte.length === 0">
                    <kiene-betriebskontakt-auswahl
                        [config]="haendlerKontaktConfig"
                        [selectedKontakte]="selectedHaendlerKontakte"
                        [disabled]="isSaving"
                        (kontaktSelected)="onHaendlerKontaktSelected($event)"
                        (kontakteSelected)="onHaendlerKontakteSelected($event)"
                    >
                    </kiene-betriebskontakt-auswahl>
                </div>
            </ng-container>
        </div>
    </section>

    <div *ngIf="showFinishInfoBox" class="info-box" style="font-size: 0.8em; margin-top: 12px">
        Beim Abschließen der Ausstallliste wird der Empfänger
        {{ tierliste.kunde_einstallen }} informiert, dass die Tiere zum eingetragenem Datum transportiert werden
        sollen.
    </div>

    <ng-container *ngIf="hasTiereOnTierliste && selectedTiereGewichte?.length > 0">
        <mat-divider style="margin: 16px 0"></mat-divider>
        <div class="weight-section">
            <h5>Abgangsgewicht (optional)</h5>
            <div class="weight-mode-group" role="radiogroup" aria-label="Abgangsgewicht auswählen">
                <button
                    type="button"
                    class="weight-mode-option"
                    [class.selected]="weightEntryMode === 'perAnimal'"
                    [attr.aria-checked]="weightEntryMode === 'perAnimal'"
                    role="radio"
                    (click)="toggleWeightEntryMode('perAnimal')"
                >
                    <mat-icon>{{
                        weightEntryMode === "perAnimal" ? "radio_button_checked" : "radio_button_unchecked"
                    }}</mat-icon>
                    <span>Pro Tier (einzeln)</span>
                </button>
                <button
                    type="button"
                    class="weight-mode-option"
                    [class.selected]="weightEntryMode === 'samePerAnimal'"
                    [attr.aria-checked]="weightEntryMode === 'samePerAnimal'"
                    role="radio"
                    (click)="toggleWeightEntryMode('samePerAnimal')"
                >
                    <mat-icon>{{
                        weightEntryMode === "samePerAnimal" ? "radio_button_checked" : "radio_button_unchecked"
                    }}</mat-icon>
                    <span>durchschnittlichestiergewicht</span>
                </button>
                <button
                    type="button"
                    class="weight-mode-option"
                    [class.selected]="weightEntryMode === 'totalOnly'"
                    [attr.aria-checked]="weightEntryMode === 'totalOnly'"
                    role="radio"
                    (click)="toggleWeightEntryMode('totalOnly')"
                >
                    <mat-icon>{{
                        weightEntryMode === "totalOnly" ? "radio_button_checked" : "radio_button_unchecked"
                    }}</mat-icon>
                    <span>Gesamtgewicht aller Tiere</span>
                </button>
            </div>

            <button
                *ngIf="selectedTiereGewichte?.length"
                type="button"
                (click)="ladeLetzteGewichte()"
                color="accent"
                mat-stroked-button
                class="weight-action-button"
            >
                Letztes Gewicht laden
            </button>

            <ng-container *ngIf="weightEntryMode === 'perAnimal'">
                <div *ngFor="let item of selectedTiereGewichte" class="weight-item">
                    <mat-form-field style="width: 100%">
                        <mat-label>{{ item.tier?.ohrmarke_notnull || item.tier?.ohrmarke || ("Tier " + item.tier?.gt_id) }}</mat-label>
                        <input [formControl]="item.gewichtCtrl" inputmode="decimal" matInput type="number" />
                        <span matSuffix>kg</span>
                    </mat-form-field>
                </div>
            </ng-container>

            <ng-container *ngIf="weightEntryMode === 'samePerAnimal'">
                <div class="weight-mode-info">Dieses Gewicht wird für {{ tierCountForWeightInfo }} Tier(e) gespeichert.</div>
                <mat-form-field style="width: 100%">
                    <mat-label>Gewicht je Tier</mat-label>
                    <input [formControl]="sameWeightCtrl" inputmode="decimal" matInput type="number" />
                    <span matSuffix>kg</span>
                </mat-form-field>
            </ng-container>

            <ng-container *ngIf="weightEntryMode === 'totalOnly'">
                <div class="weight-mode-info">
                    Das Gesamtgewicht wird für {{ tierCountForWeightInfo }} Tier(e) gespeichert (keine Einzelgewichte).
                </div>
                <mat-form-field style="width: 100%">
                    <mat-label>Gesamtgewicht</mat-label>
                    <input [formControl]="totalWeightCtrl" inputmode="decimal" matInput type="number" />
                    <span matSuffix>kg</span>
                </mat-form-field>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-template #ausstallenFooterActions>
    <div *ngIf="saveBlockedMessage && !isSaving" class="save-blocked-hint">
        {{ saveBlockedMessage }}
    </div>
    <ng-container *ngIf="embeddedInStepper || embeddedAsMobilePage; else dialogFooterActions">
        <!-- Finish step: primary action lives in sticky mobile page header -->
        <ng-container *ngIf="!(embeddedAsMobilePage && mobileFinishMode)">
            <button
                type="button"
                (click)="save()"
                *kienePermission="[9322]"
                [disabled]="isSaving || !canSave"
                [class.ausstallen-mobile-page-save]="embeddedAsMobilePage"
                color="accent"
                mat-flat-button
            >
                {{
                    embeddedAsMobilePage
                        ? mobilePagePrimaryLabel
                        : embeddedCreateButtonLabel
                }}
            </button>
        </ng-container>
        <button *ngIf="embeddedInStepper" type="button" (click)="close()" mat-button>Zurück</button>
    </ng-container>
    <ng-template #dialogFooterActions>
        <span class="spacer"></span>
        <button type="button" (click)="close()" mat-button>Abbrechen</button>
        <button type="button" (click)="save()" *kienePermission="[9322]" [disabled]="isSaving || !canSave" color="accent" mat-flat-button>
            {{ tierliste.tierliste_id ? "Speichern" : "Scans fortsetzen" }}
        </button>
    </ng-template>
</ng-template>

<!-- Dialog-Variante -->
<ng-container *ngIf="!embeddedInStepper && !embeddedAsMobilePage">
    <h1 mat-dialog-title>Ausstallen</h1>

    <div mat-dialog-content>
        <ng-container *ngTemplateOutlet="ausstallenFormInner"></ng-container>
    </div>

    <div mat-dialog-actions>
        <ng-container *ngTemplateOutlet="ausstallenFooterActions"></ng-container>
    </div>
</ng-container>

<!-- Eingebettet im Dashboard-Stepper (5. Schritt) -->
<div
    *ngIf="embeddedInStepper && !embeddedAsMobilePage"
    class="ausstallen-dialog-embedded"
    [class.ausstallen-dialog-embedded--external-footer]="hideEmbeddedFooter"
>
    <h2 class="ausstallen-dialog-embedded__title">{{ embeddedTitle }}</h2>
    <div class="ausstallen-dialog-embedded__scroll">
        <ng-container *ngTemplateOutlet="ausstallenFormInner"></ng-container>
    </div>
    <div *ngIf="!hideEmbeddedFooter" class="ausstallen-dialog-embedded__footer">
        <ng-container *ngTemplateOutlet="ausstallenFooterActions"></ng-container>
    </div>
</div>

<!-- Kundenportal mobile: full-page route (bottom nav stays visible) -->
<div *ngIf="embeddedAsMobilePage" class="ausstallen-dialog-mobile-page">
    <div class="ausstallen-dialog-mobile-page__scroll">
        <ng-container *ngTemplateOutlet="ausstallenFormInner"></ng-container>
    </div>
    <div
        *ngIf="!mobileFinishMode || (saveBlockedMessage && !isSaving)"
        class="ausstallen-dialog-mobile-page__footer"
    >
        <ng-container *ngTemplateOutlet="ausstallenFooterActions"></ng-container>
    </div>
</div>
